import "./App.css";
import backgroundImage from "./_background-wine-wave-elegant.jpg";

const data = [
  {
    text: "Pretty aromas of yellow flower and stone fruit lead the nose",
    title: "Stemmari 2013 Dalila White (Terre Siciliane)",
    image: "pretty-aromas.png",
    hueRotate: -10,
  },
  {
    text: "melon flavors feel supple and silky on the palate",
    title: "Weingut Liebfrauenstift 2014 Dry Riesling (Rheinhessen)",
    image: "melon-flavors.png",
  },
  {
    text: "the distinctive nose on this bottling is tight yet tropical",
    title: "R2 2013 Camp 4 Vineyard Grenache Blanc (Santa Ynez Valley)",
    image: "tight-yet-tropical.png",
    hueRotate: 80,
  },
  {
    text: "Complex and inviting nose layered with a strong earthy minerality",
    title:
      "Dopff & Irion 2004 Schoenenbourg Grand Cru Vendanges Tardives Riesling (Alsace)",
    image: "minerality.png",
  },
  {
    text: "The dense palate delivers toast, leather and cedar alongside teeth-coating tannins",
    title: "Tenuta Forconi 2013 Toscano Red (Toscana)",
    image: "dense-palate.png",
  },
  {
    text: "Poached pears, yellow apples and a touch of butter show on the classic nose",
    title: "Pull 2013 Chardonnay (Paso Robles)",
    image: "poached-peers.png",
  },
  {
    text: "Red fruit aromas pervade on the nose, with cigar box and menthol notes riding in the back",
    title: "Quiévremont 2012 Meritage (Virginia)",
    image: "redfruit-cigarbox.png",
    hueRotate: -60,
  },
  {
    text: "Desiccated blackberry, leather, charred wood and mint aromas carry the nose",
    title:
      "Pradorey 2010 Vendimia Seleccionada Finca Valdelayegua Single Vineyard Crianza (Ribera del Duero)",
    image: "desiccated-blackberry.png",
    hueRotate: 40,
  },
  {
    text: "There are intriguing touches to the nose of this bottling, with jasmine, sea salt, wet hay, quinine and rainy sidewalk",
    title: "Roco 2014 Gravel Road Pinot Noir (Willamette Valley)",
    image: "rainy-sidewalk.png",
    hueRotate: 120,
  },
  {
    text: "a bright nose with green apple and citric aromas comes with mild oak",
    title: "Leyda 2015 Single Vineyard Falaris Hill Chardonnay (Leyda Valley)",
    image: "bright-nose-green-apple.png",
    hueRotate: 10,
  },
  {
    text: "The nose reveals yellow fruits and a hint of white flowers",
    title: "Crémant de Loire Brut",
    image: "yellow-nose.png",
    hueRotate: 10,
  },
  {
    text: "In the mouth, this is fairly full bodied, with tomatoey acidity",
    title: "Tandem 2011 Ars In Vitro Tempranillo-Merlot (Navarra)",
    image: "full-bodied-tomato.png",
    hueRotate: -60,
  },
  {
    text: "The wine hits the palate like a fleshy fist, with an intense, grassy gooseberry flavor that provides plenty of punch",
    title: "Trump 2011 Sauvignon Blanc (Monticello)",
    image: "fleshy-fist.png",
    hueRotate: -120,
  },
];

function App() {
  return (
    <div className="App">
      <header>
        <img src="images/winetasting-illustration.png" alt=""></img>
        <div>
          <h1>Wine Tasting Notes txt2img</h1>
          <p>Sorted in the direction: subtle&poetic --> bold&gross </p>
        </div>
      </header>
      {data.map((el) => (
        <div key={el.text} className="dataRow">
          <img
            className="dataRow__genimg"
            src={`images/${el.image}`}
            alt=""
          ></img>
          <div className="dataRow__meta">
            <p
              className="dataRow__prompt"
              style={{ backgroundImage: backgroundImage }}
            >
              {el.text}
            </p>
            <div className="dataRow__info">
              <img
                className="dataRow__bottle"
                src={"images/neutral-bottle.png"}
                style={{ filter: `hue-rotate(${el.hueRotate || 1}deg)` }}
                alt=""
              ></img>
              <small>{el.title}</small>
            </div>
          </div>
        </div>
      ))}
      <footer>
        <p>
          These images were generated with a{" "}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://alexasteinbruck.medium.com/vqgan-clip-how-does-it-work-210a5dca5e52"
          >
            text-to-image model
          </a>
          . <br />
          The textual inputs are (excerpts of) existing wine tasting notes for
          real wines.
        </p>
        (All beverages tasted and approved) by{" "}
        <a href="https://twitter.com/alexabruck">Alexa Steinbrück </a>:-)
      </footer>
    </div>
  );
}

export default App;
